module.exports = __webpack_public_path__ + "media/images/pic/hero/courses/school/preschool-7a1020d1d85c3582c808e1fcdd0d0363.jpeg";